import PermissionChecker from 'src/modules/auth/permissionChecker';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface PublicRouteProps {
  component: React.ComponentType<any>;
  currentTenant: any;
  currentUser: any;
}

function PublicRoute({
  component: Component,
  currentTenant,
  currentUser,
}: PublicRouteProps) {
  const permissionChecker = new PermissionChecker(
    currentTenant,
    currentUser,
  );

  if (permissionChecker.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
}

export default PublicRoute;
